import { render, staticRenderFns } from "./forgetItem.vue?vue&type=template&id=57450800&scoped=true&"
import script from "./forgetItem.vue?vue&type=script&lang=js&"
export * from "./forgetItem.vue?vue&type=script&lang=js&"
import style0 from "./forgetItem.vue?vue&type=style&index=0&id=57450800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57450800",
  null
  
)

export default component.exports